"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx } from "react/jsx-runtime";
var _a;
import { Component, useContext } from "react";
import { Router, Route, matchPath, __RouterContext } from "react-router";
import { Link as RouterLink } from "react-router-dom";
import { dequal } from "dequal";
import {
  toLocation
} from "./legacy_history";
function matchRoutes(routes, pathname, underLayout) {
  const atRoot = underLayout && pathname === "/";
  for (const route of routes) {
    const allPaths = Array.isArray(route.path) ? route.path : [route.path];
    const paths = atRoot ? allPaths.filter((path) => path === "/") : allPaths;
    for (const path of paths) {
      const match = matchPath(pathname, { path, exact: true });
      if (match) return { route, params: match.params };
    }
  }
  return null;
}
function enterHook(route) {
  if (!route.redirectTo) return route.onEnter;
  const pathname = route.redirectTo;
  return ({ location }, replace) => replace({ pathname, query: location.query, state: location.state });
}
function createTransitionHistory(history, routes, underLayout) {
  let committed;
  const listeners = /* @__PURE__ */ new Set();
  function transitionTo(location) {
    const match = matchRoutes(routes, location.pathname, underLayout);
    const layoutOnly = underLayout && location.pathname === "/";
    if (!match && !layoutOnly && committed) return;
    const previous = committed == null ? void 0 : committed.match;
    const entering = match && ((previous == null ? void 0 : previous.route) !== match.route || !dequal(previous.params, match.params));
    const onEnter = entering ? enterHook(match.route) : void 0;
    let redirect = null;
    onEnter == null ? void 0 : onEnter({ location, params: match.params }, (to) => redirect = to);
    if (redirect) {
      history.replace(redirect);
      return;
    }
    committed = { location, match };
    listeners.forEach((listener) => listener(location));
  }
  let stopListening = null;
  function start() {
    stopListening != null ? stopListening : stopListening = history.listen(transitionTo);
  }
  function stop() {
    stopListening == null ? void 0 : stopListening();
    stopListening = null;
  }
  start();
  transitionTo(history.getCurrentLocation());
  return Object.create(history, {
    location: { get: () => committed.location },
    listen: {
      value: (listener) => {
        listeners.add(listener);
        return () => listeners.delete(listener);
      }
    },
    start: { value: start },
    stop: { value: stop },
    match: {
      value: (pathname) => matchRoutes(routes, pathname, underLayout)
    }
  });
}
const sharedTransitions = /* @__PURE__ */ new WeakMap();
function sharedFor(history, routes) {
  let byRoutes = sharedTransitions.get(history);
  if (!byRoutes) {
    byRoutes = /* @__PURE__ */ new Map();
    sharedTransitions.set(history, byRoutes);
  }
  let byLayout = byRoutes.get(routes);
  if (!byLayout) {
    byLayout = /* @__PURE__ */ new Map();
    byRoutes.set(routes, byLayout);
  }
  return byLayout;
}
export default class LegacyRouter extends Component {
  constructor() {
    super(...arguments);
    // Routes are read once, as react-router 3 ignored changes to them.
    __publicField(this, "history", this.props.history);
    __publicField(this, "routes", this.props.routes);
    __publicField(this, "underLayout", !!this.props.layout);
    __publicField(this, "shared", (_a = sharedFor(this.history, this.routes).get(this.underLayout)) != null ? _a : this.share({
      transitions: createTransitionHistory(
        this.history,
        this.routes,
        this.underLayout
      ),
      mounts: 0
    }));
    __publicField(this, "transitions", this.shared.transitions);
  }
  componentDidMount() {
    this.share(this.shared);
    this.shared.mounts++;
    this.transitions.start();
  }
  componentWillUnmount() {
    var _a2;
    this.shared.mounts--;
    if (this.shared.mounts > 0) return;
    this.transitions.stop();
    const byLayout = sharedFor(this.history, this.routes);
    byLayout.delete(this.underLayout);
    if (byLayout.size === 0) {
      (_a2 = sharedTransitions.get(this.history)) == null ? void 0 : _a2.delete(this.routes);
    }
  }
  share(shared) {
    sharedFor(this.history, this.routes).set(this.underLayout, shared);
    return shared;
  }
  render() {
    const { layout: Layout } = this.props;
    return /* @__PURE__ */ jsx(Router, { history: this.transitions, children: /* @__PURE__ */ jsx(
      Route,
      {
        render: ({ location }) => {
          const match = this.transitions.match(location.pathname);
          if (!match && Layout && location.pathname === "/") {
            return /* @__PURE__ */ jsx(Layout, { location, params: {} });
          }
          if (!(match == null ? void 0 : match.route.component)) return null;
          const props = { location, params: match.params };
          const Page = match.route.component;
          if (!Layout) return /* @__PURE__ */ jsx(Page, __spreadValues({}, props));
          return /* @__PURE__ */ jsx(Layout, __spreadProps(__spreadValues({}, props), { children: /* @__PURE__ */ jsx(Page, __spreadValues({}, props)) }));
        }
      }
    ) });
  }
}
export function Link(_b) {
  var _c = _b, { to } = _c, props = __objRest(_c, ["to"]);
  const router = useContext(__RouterContext);
  if (!router) return /* @__PURE__ */ jsx("a", __spreadValues({}, props));
  return /* @__PURE__ */ jsx(RouterLink, __spreadValues({ to: toLocation(to) }, props));
}
